import ContentLoader from "react-content-loader";
import styled from "styled-components";

const LoaderStyles = styled(ContentLoader)`
  width: 100%;
  height: 100%;
`;

export default LoaderStyles;
